import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";

const StyledFlag = styled.img`
  margin: 0;
  width: 18px;
`;

const FlagIcon = ({ name = "" }) => {
  return <></>;
  // const { flagImages, site } = useStaticQuery(graphql`
  //     query {
  //         flagImages: allFile(
  //             filter: { relativeDirectory: { eq: "flags" } }
  //         ) {
  //             nodes {
  //                 publicURL
  //                 name
  //             }
  //         }
  //     }
  // `)
  // if (name) {
  //     const flagIcon = flagImages.nodes.find(
  //         (f) => f.name === name.replace(/\s+/g, "").replace(/&/g, "and")
  //     )
  //     return <StyledFlag src={flagIcon && flagIcon.publicURL} />
  // } else {
  //     return <></>
  // }
};

export default FlagIcon;
